import React from 'react';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { SvgIconProps } from '@mui/material';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import DoneIcon from '@mui/icons-material/Done';
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import WarningOutlinedIcon from '@mui/icons-material/WarningOutlined';
import LaunchIcon from '@mui/icons-material/Launch';
import ImportExportOutlinedIcon from '@mui/icons-material/ImportExportOutlined';
import FolderZipIcon from '@mui/icons-material/FolderZipOutlined';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';

export const ThemedDeleteIcon: React.FC<SvgIconProps> = (props) => {
  return <DeleteOutlinedIcon color="error" {...props} />;
};

export const ThemedDoneIcon: React.FC<SvgIconProps> = (props) => {
  return <DoneIcon color="success" {...props} />;
};

export const ThemedEditNoteIcon: React.FC<SvgIconProps> = (props) => {
  return <EditNoteOutlinedIcon color="primary" {...props} />;
};

export const ThemedCopyIcon: React.FC<SvgIconProps> = (props) => {
  return <FileCopyOutlinedIcon color="success" {...props} />;
};

export const ThemedEditIcon: React.FC<SvgIconProps> = (props) => {
  return <ModeEditOutlineOutlinedIcon color="info" {...props} />;
};

export const ThemedWarningIcon: React.FC<SvgIconProps> = (props) => {
  return <WarningOutlinedIcon color="warning" {...props} />;
};

export const ThemedLaunchIcon: React.FC<SvgIconProps> = (props) => {
  return <LaunchIcon color="info" {...props} />;
};

export const ThemedImportIcon: React.FC<SvgIconProps> = (props) => {
  return <ImportExportOutlinedIcon color="success" {...props} />;
};

export const ThemedFolderZipIcon: React.FC<SvgIconProps> = (props) => {
  return <FolderZipIcon color="warning" {...props} />;
};

export const ThemedRefreshIcon: React.FC<SvgIconProps> = (props) => {
  return <AutorenewIcon color="primary" {...props} />;
};

export const ThemedVisibilityIcon: React.FC<SvgIconProps> = (props) => {
  return <VisibilityOutlinedIcon color="primary" {...props} />;
};

export const ThemedVisibilityOffIcon: React.FC<SvgIconProps> = (props) => {
  return <VisibilityOffOutlinedIcon color="primary" {...props} />;
};
